import React, { useState, useEffect } from "react";
import "./styles/global.css"; // Estilos globales
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import About from "./pages/About";
import Services from "./pages/Services";
import Contact from "./pages/Contact";

function App() {
  const [mensaje, setMensaje] = useState("");

  useEffect(() => {
    // Llamada al backend
    fetch("http://127.0.0.1:5000/api/saludo")
      .then((response) => response.json())
      .then((data) => setMensaje(data.mensaje))
      .catch((error) =>
        console.error("Error al conectar con el backend:", error)
      );
  }, []);

  return (
    <div className="App">
      <Header />
      <main>
        <Home />
        <About />
        <Services />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}

export default App;
